export default __webpack_public_path__ + "static/media/about1.12b81500.png";